import { Suspense, useEffect, useState } from "react"
import PageHeader from "../../components/PageHeader/PageHeader"
import { Paper, Tab, Tabs } from "@mui/material"
import { Link, useLocation } from "react-router-dom"
import { CATEGORY_1, CATEGORY_2, CATEGORY_3, ROOT } from "../../constants/path"
import { GridParent, StyledTabPanel } from "./styles"
import Category1 from "./Category1"
import Category2 from "./Category2"
import Category3 from "./Category3"

export const Categories = () => {
  const location = useLocation()
  const { pathname } = location
  const [activeTab, setActiveTab] = useState("/category1") // Default active tab is "category1"

  useEffect(() => {
    // Determine active tab based on pathname
    if (pathname.includes("/category1")) {
      setActiveTab("/category1")
    } else if (pathname.includes("/category2")) {
      setActiveTab("/category2")
    } else if (pathname.includes("/category3")) {
      setActiveTab("/category3")
    }
  }, [pathname])

  return (
    <GridParent>
      <PageHeader
        title="Categories"
        breadcrums={[{ title: "Home", path: ROOT }, { title: "Categories" }]}
      />
      <>
        <Paper
          style={{
            marginTop: "-10px",
            backgroundColor: "#fff",
            width: "100%",
            paddingTop: 10,
          }}
        >
          <Tabs value={activeTab}>
            <Tab
              label="Category 1"
              value="/category1"
              component={Link}
              to={CATEGORY_1}
            />
            <Tab
              label="Category 2"
              value="/category2"
              component={Link}
              to={CATEGORY_2}
            />
            <Tab
              label="Category 3"
              value="/category3"
              component={Link}
              to={CATEGORY_3}
            />
          </Tabs>
        </Paper>
        <TabPanel value={activeTab} index="/category1">
          {activeTab === "/category1" && (
            <Suspense fallback={<div>Loading...</div>}>
              <Category1 />
            </Suspense>
          )}
        </TabPanel>
        <TabPanel value={activeTab} index="/category2">
          {activeTab === "/category2" && (
            <Suspense fallback={<div>Loading...</div>}>
              <Category2 />
            </Suspense>
          )}
        </TabPanel>
        <TabPanel value={activeTab} index="/category3">
          {activeTab === "/category3" && (
            <Suspense fallback={<div>Loading...</div>}>
              <Category3 />
            </Suspense>
          )}
        </TabPanel>
      </>
    </GridParent>
  )
}

type TabPanelProps = {
  children: React.ReactNode
  value: string
  index: string
}

const TabPanel: React.FC<TabPanelProps> = ({ children, value, index }) => {
  return <StyledTabPanel hidden={value !== index}>{children}</StyledTabPanel>
}
